import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingService } from "../../services/Landing_Services/landing.service";
import { Testimonial } from "../../utilities/interfaces/CMS_Interfaces/testimonial_interfaces/testimonial.interface";
import { Portfolio } from "../../utilities/interfaces/CMS_Interfaces/portfolio_interfaces/portfolio.interface";

@Component({
  selector: "app-testimonials",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./testimonials.component.html",
  styleUrl: "./testimonials.component.css",
})
export class TestimonialsComponent implements OnInit {
  testimonials: Testimonial[] | null = null;
  portfolios: Portfolio[] | null = null;

  constructor(private landingService: LandingService) {}

  ngOnInit(): void {
    this.loadTestimonials();
    this.loadPortfolios();
  }

  private loadTestimonials(): void {
    this.landingService.getTestimonials().subscribe({
      next: (data) => {
        this.testimonials = data.sort(
          (a, b) => (a.weight || 0) - (b.weight || 0),
        );
        setTimeout(() => this.initScrollAnimations(), 0);
      },
      error: (err) => {
        console.error("Error loading testimonials:", err);
      },
    });
  }

  private loadPortfolios(): void {
    this.landingService.getPortfolios().subscribe({
      next: (data) => {
        this.portfolios = data
          .filter((p) => p.status === "Active")
          .sort((a, b) => (a.weight || 0) - (b.weight || 0));
      },
      error: (err) => {
        console.error("Error loading portfolios:", err);
      },
    });
  }

  private initScrollAnimations() {
    if (typeof document === "undefined") return;
    setTimeout(() => {
      const reveals = document.querySelectorAll(".testimonials-grid .reveal");
      if (!reveals.length) return;

      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("active");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        },
      );

      reveals.forEach((reveal) => {
        revealObserver.observe(reveal);
      });
    }, 100);
  }

  stripHtml(html: string): string {
    if (!html) return "";
    if (typeof document !== "undefined") {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    }
    return html.replace(/<[^>]*>/g, "").trim();
  }

  getInitial(name: string): string {
    return name ? name.charAt(0).toUpperCase() : "?";
  }
}
